export default __webpack_public_path__ + "static/media/stepper3.40053ac2.png";